<template>
  <div :style="style">
      <CktextComponent :rawHtml="rawHtml">    
      </CktextComponent>
  </div>
</template>

<script>
import CktextComponent from '../CkText.vue';

export default {
  name: 'RichText',
  components: {
    CktextComponent
  },
  data(){
    return {
      rawHtml:'',
      style:''
    }
  },
  props: {
    component: null
  },
  created(){
    
    this.style=this.$common.generateStyle(this.component.data.style);

    this.rawHtml=this.component.data.data;

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>
